// src/utils/resolveInfoContent.js
export function resolveInfoContent({ t, infoKey, titleFallback }) {
  if (!infoKey) return null;
  const get = (k) => t(k, { defaultValue: "" });

  // Preferred: metricDefinitions schema
  const mdTitle = get(`${infoKey}.title`);
  const mdSubtitle = get(`${infoKey}.subtitle`);
  const mdDesc = get(`${infoKey}.description`);
  const mdWhy = get(`${infoKey}.why`);

  // Only treat as metric schema if there is actual metric body content
  if ((mdDesc && mdDesc.trim()) || (mdWhy && mdWhy.trim())) {
    const headingWhat = t("metricHeadings.what", {
      defaultValue: "What is it?",
    });
    const headingWhy =
      mdSubtitle ||
      t("metricHeadings.why", { defaultValue: "Why this metric?" });

    const sections = [];
    if (mdDesc) sections.push({ heading: headingWhat, body: mdDesc });
    if (mdWhy) sections.push({ heading: headingWhy, body: mdWhy });

    return {
      title: mdTitle || titleFallback || "",
      intro: "",
      sections,
      singleBody: "",
    };
  }

  // Fallback: old schema (.intro + .sections[])
  const stTitle = get(`${infoKey}.title`) || get(infoKey);
  const intro = get(`${infoKey}.intro`);
  const sections = [];
  for (let i = 0; i < 10; i++) {
    const h = get(`${infoKey}.sections.${i}.heading`);
    const b = get(`${infoKey}.sections.${i}.body`);
    if (!h && !b) break;
    sections.push({ heading: h, body: b });
  }
  const singleBody = !intro && sections.length === 0 ? get(infoKey) : "";

  return {
    title: stTitle || titleFallback || "",
    intro,
    sections,
    singleBody,
  };
}
